onComplete(function() {

	const input = document.querySelector('.search-page input[name="q"]');

	if (input) {

		const phrases = [
			"Wat is palliatieve zorg?",
			"Hoe begin ik het gesprek over later?",
			"Waar vind ik hulp in mijn regio?",
			"Hoe kan ik mijn naaste steunen?"
		];

		// Configuration for the typing speed (in milliseconds)
		const typingSpeed = 100;
		const erasingSpeed = 50;
		const pauseTime = 1500; // Pause after a phrase is fully typed

		let phraseIndex = 0;
		let charIndex = 0;
		let typingTimeout;
		let erasingTimeout;

		/**
		 * Clears any running timeouts to stop the animation.
		 */
		function stopAnimation () {
			clearTimeout(typingTimeout);
			clearTimeout(erasingTimeout);
			// Ensure the placeholder is completely clear when focused
			input.placeholder = "";
		}

		/**
		 * Types a single character onto the placeholder.
		 */
		function type () {
			if (input === document.activeElement) {
				// If the element is currently focused, stop the animation
				stopAnimation();
				return;
			}

			if (charIndex < phrases[phraseIndex].length) {
				input.placeholder += phrases[phraseIndex].charAt(charIndex);
				charIndex++;
				typingTimeout = setTimeout(type, typingSpeed);
			} else {
				typingTimeout = setTimeout(erase, pauseTime);
			}
		}

		/**
		 * Erases a single character from the placeholder.
		 */
		function erase () {
			if (input === document.activeElement) {
				stopAnimation();
				return;
			}

			if (charIndex > 0) {
				input.placeholder = phrases[phraseIndex].substring(0, charIndex - 1);
				charIndex--;
				erasingTimeout = setTimeout(erase, erasingSpeed);
			} else {
				phraseIndex = (phraseIndex + 1) % phrases.length;
				charIndex = 0;
				typingTimeout = setTimeout(type, typingSpeed);
			}
		}

		input.addEventListener('focus', stopAnimation);

		input.addEventListener('blur', () => {
			if (input.value.trim() === '') {
				// Reset state to start the animation fresh
				phraseIndex = 0;
				charIndex = 0;
				input.placeholder = ""; // Ensure it's empty before starting
				type();
			}
		});

		type()
	}
});